import { FinancialAccountNode } from './interfaces';
import { orgsRequest } from './request';

const FINANCIAL_ACCOUNT_ORG_QUERY = `
query FinancialAcctOrg($orgId: ID!) {
  financialAcctOrg(orgId: $orgId) {
    orgId
    orgName
    kybId
    finAcctId
    processor
    status
    acctId
    applicationId
    customerId
    createdAt
    updatedAt
    stripeEnv
    paymentMethodId
    customerId
  }
}`;

export const financialAcctOrg = async (
  orgId: string,
): Promise<FinancialAccountNode[]> => {
  const financialAcctOrgRes = await orgsRequest(FINANCIAL_ACCOUNT_ORG_QUERY, {
    orgId,
  });
  const financialAcctOrgJson = await financialAcctOrgRes.json();
  return financialAcctOrgJson.data.financialAcctOrg;
};

const GET_FINANCIAL_ACCT_ORG_BY_KYC_QUERY = `
query FinancialAcctOrgByKyb($kybId: ID!) {
  financialAcctOrgByKyb(kybId: $kybId) {
    acctId
    processor
  }
}
`;

export const getFinancialAcctOrgByKybId = async (
  kybId: string,
): Promise<FinancialAccountNode[]> => {
  const financialAcctOrgRes = await orgsRequest(
    GET_FINANCIAL_ACCT_ORG_BY_KYC_QUERY,
    {
      kybId,
    },
  );
  const financialAcctOrgResJson = await financialAcctOrgRes.json();
  return financialAcctOrgResJson.data.financialAcctOrgByKyb;
};
